Vue.component('TournamentForm', {
    template: templates.TournamentForm,
    props: {
        model: {
            type: Object,
            required: true
        },
        players: {
            type: Array,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        battleOptions: {
            type: Array,
            required: true
        }
    },
    computed: {
        // Use computed properties for reactive access to nested data
        tournament() {
            return this.model || {};
        }
    },
    mounted() {
        console.log('TournamentForm mounted');
    },
    methods: {
        // Emit changes directly without storing local copies
        updateField(field, value) {
            this.$emit('input-changed', { 
                tournament: { 
                    ...this.tournament, 
                    [field]: value 
                } 
            });
        },
        
        // Handle faction logic with proper updates
        handleFactionChange(value) {
            const updatedTournament = { ...this.tournament, faction: value };
            
            // If faction is disabled, also disable faction wars
            if (!value) {
                updatedTournament.universalFaction = false;
                updatedTournament.innerFaction = false;
            }
            
            console.log(updatedTournament)
            this.$emit('input-changed', { tournament: updatedTournament });
        },
        
        handleUniversalFactionChange(value) {
            const updatedTournament = { ...this.tournament, universalFaction: value };
            
            // If universal faction is enabled, disable inner faction
            if (value) {
                updatedTournament.innerFaction = false;
            }
            
            this.$emit('input-changed', { tournament: updatedTournament });
        },
        
        handleInnerFactionChange(value) {
            const updatedTournament = { ...this.tournament, innerFaction: value };
            
            // If inner faction is enabled, disable universal faction
            if (value) {
                updatedTournament.universalFaction = false;
            }
            
            this.$emit('input-changed', { tournament: updatedTournament });
        }
    }
    // Removed all watchers to prevent circular updates
});